import { DesignTokens, GivelifyButton, GivelifyLabel } from '@givelify/ui';
import {
    CardWrapper,
    ModalContent,
    ModalFooter,
    ModalHeader,
    OrganizationCard,
} from './style';
import worshipIcon from '../../../../assets/worship-icon.svg';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes';
import { useTranslation } from 'react-i18next';
import { pushEvent } from 'utils/clevertapUtils';
import { CLICK_EVENT, VIEW_EVENT } from 'utils/clevertapEvents';

export const NoSuggestions: React.FC = () => {
    const { t } = useTranslation();
    const push = useNavigate();
    const { name, organizationLocation } = useSelector((state: AppState) => ({
        name: state.Signup.organizationName,
        organizationLocation: state.Signup.organizationLocation,
    }));

    const copy = useMemo(
        () => ({
            heading: t('signup.organizationSearch.noSuggestions.heading'),
            tellMore: t('signup.organizationSearch.noSuggestions.tellMore'),
            next: t('signup.organizationSearch.noSuggestions.next'),
        }),
        [t],
    );

    useEffect(() => {
        pushEvent(VIEW_EVENT, {
            name: 'SignupYourNew',
        });
    }, []);

    const address = useMemo(() => {
        const { city, state, zip, userTypedValue } = organizationLocation;
        if (!city || !state) {
            return userTypedValue;
        } else {
            return `${city}, ${state}` + (zip ? `, ${zip}` : '');
        }
    }, [organizationLocation]);

    const onNext = () => {
        pushEvent(CLICK_EVENT, {
            name: 'Next',
            location: 'SignupYourNew'
        });
        push(PATH.SIGNUP.STEPS.ADD_ORGANIZATION);
    };

    return (
        <>
            <ModalHeader className={`no-results fs-unmask`}>
                <GivelifyLabel text={copy.heading} variant="heading3S" />
            </ModalHeader>
            <ModalContent className={`no-results fs-unmask`}>
                <CardWrapper>
                    <OrganizationCard>
                        <div className="background">
                            <img src={worshipIcon} alt="icon" />
                        </div>
                        <div className="content">
                            <GivelifyLabel variant="body1B" text={name} />
                            <GivelifyLabel variant="body2" text={address} />
                        </div>
                    </OrganizationCard>
                </CardWrapper>
            </ModalContent>
            <ModalFooter className={`no-results fs-unmask`}>
                <GivelifyLabel
                    text={copy.tellMore}
                    variant="body1"
                    color={DesignTokens.color.textSecondary}
                />
                <GivelifyButton
                    text={copy.next}
                    variant="primary"
                    className="next"
                    onClick={onNext}
                    name="next"
                />
            </ModalFooter>
        </>
    );
};
